import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { AbstractError } from "@errors/AbstractError";
export var UnexpectedError = /*#__PURE__*/ function(AbstractError) {
    "use strict";
    _inherits(UnexpectedError, AbstractError);
    var _super = _create_super(UnexpectedError);
    function UnexpectedError(params) {
        var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "予期せぬエラーが発生しました";
        _class_call_check(this, UnexpectedError);
        return _super.call(this, params, errorMessage);
    }
    return UnexpectedError;
}(AbstractError);
